<template>
  <div>
    <el-tabs v-model="currentTabIndex" class="tabs-list">
<!--      <el-tab-pane label="版权声明" name="first" class="tabs-content">-->
<!--        <copyright></copyright>-->
<!--      </el-tab-pane>-->
      <el-tab-pane label="Statement" name="second" class="tabs-content">
        <download></download>
      </el-tab-pane>
    </el-tabs>

    <DialogList
      :dialogVisible="dialogTableVisibleNew"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />
  </div>
</template>

<script>
import copyright from "./module/copyright.vue";
import download from "./module/download.vue";
import DialogList from "../materialDownload/module/dialog.vue";
import Accountdialog from "../materialDownload/module/accountdialog";
export default {
  components: {
    copyright,
    download,
    DialogList,
    Accountdialog
  },
  data() {
    return {
      currentTabIndex: "second",
      dialogTableVisibleNew: false, //费用明细弹窗
      accountDialogTableVisible: false, //余额弹窗
    };
  },
  mounted(){
    this.$EventBus.$on("constDetailOut", (data) => {
      this.openConstDetailPop()
    })

    this.$EventBus.$on("accountDetailOut", (data) => {
      this.openAccountDetailPop()
    })
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-78962210-9');
  },
  methods: {
    //费用明细
    openConstDetailPop() {
      this.dialogTableVisibleNew = true;
    },
    closeConstDetailPop() {
      this.dialogTableVisibleNew = false;
    },
    //余额明细
    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },
    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tabs-content {
  border-radius: 4px;
  padding: 0 40px;
  margin-bottom: 10px;
  padding: 30px 40px;
}
</style>